import { SOCIAL_NETWORK_ORDER, SocialNetwork } from 'models/socialCampaign'

import { useMemo } from 'react'
import { useUserData } from 'components/contexts/UserDataContext'

/** Who a network's preview shows as the post's author. */
export interface PreviewAccount {
  name: string
  /** The account's picture; its initials otherwise */
  avatarUrl?: string | null
}

export type PreviewAccounts = Partial<Record<SocialNetwork, PreviewAccount>>

/**
 * The name the previews give the post's author, network by network: the connected account of the network once
 * ISSUE-3625 exposes them, until then the campaign's workspace (its name, initials for an avatar). A workspace the
 * viewer's profile does not list gives nothing: the preview then says "Your Instagram account".
 */
export const usePreviewAccounts = (workspaceId: string): PreviewAccounts => {
  const { clientData } = useUserData()
  const workspaces = clientData?.workspaces
  return useMemo(() => {
    const name = workspaces?.find((workspace) => workspace.id === workspaceId)?.name?.trim()
    if (!name) return {}
    return Object.fromEntries(SOCIAL_NETWORK_ORDER.map((network) => [network, { name }])) as PreviewAccounts
  }, [workspaces, workspaceId])
}
